import { MoovConfigurationDTO } from "../DTO/moovConfigurationDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateMoovConfigurationRequest extends BasicRequest{
   
    public moovConfiguration! : MoovConfigurationDTO;
    
    constructor(){
        super()
    }
}